import "@fontsource/inter";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

export const FONT_SRC = "https://fonts.googleapis.com/css?family=Inter";
